const axios = require("axios");

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';

export { axios };

const axiosHeader = axios.create({
    baseURL: '/api/'
});

axiosHeader.interceptors.response.use(response => {
    return response;
}, error => {
    return Promise.reject(error);
})

export const httpAuthRequest = async (method, url, data) => {

    try {
        const config = {
            method: method,
            url: url,
            headers: {
                Authorization: 'Bearer ' + sessionStorage.getItem("auth_token"),
            },
            data: data
        }
        const response = await axiosHeader(config)
        return { success: true, data: response.data }
    } catch (error) {
        return { success: false, data: error.response.data }
    }
}

export const httpRequest = async (method, url, data) => {

    try {
        const config = {
            method: method,
            url: url,
            data: data
        }

        const response = await axiosHeader(config);
        return { success: true, data: response.data }
    } catch (error) {
        return { success: false, data: error }
    }
}
